import { ref } from "vue";

export const useHandleBasket = (productData, taxStatus) => {
	const basket = ref({
		products: [],
		personalisation: [
			{
				logo: null,
				location: "",
				type: "",
				numberOfColours: "",
				large: false, // Based on global types
				setup: 0.0,
				price_type: "", // Based on global types
				error: "",
				price_per_item: 0.0,
			},
		],
		comments: "",
		total: 0.0,
	});

	const calculateTotal = () => {
		if (!basket.value.products.length) return (basket.value.total = 0.0);

		const numberOfItemsInBasket = basket.value.products.reduce(
			(accumulator, product) => {
				return (
					accumulator +
					product.products.reduce((accumulator, product) => {
						return accumulator + parseInt(product.qty);
					}, 0)
				);
			},
			0
		);

		if (numberOfItemsInBasket === 0) return (basket.value.total = 0.0);

		const discountPerUnitData = productData.value.pricing.find((price) => {
			return (
				numberOfItemsInBasket >= price.min_quantity &&
				(price.max_quantity
					? numberOfItemsInBasket <= price.max_quantity
					: true)
			);
		});

		const discountPerUnit = discountPerUnitData
			? discountPerUnitData.discount
			: 0;

		const totalBasketValueWithoutPersonalisation = basket.value.products.reduce(
			(acc, product) => {
				const pricePerTypeInBasket = product.products.reduce((acc, item) => {
					const priceForSize = product.stock.find(
						(stock) => stock.variation_id === item.variation_id
					).price;
					const singleItemPrice = priceForSize - discountPerUnit;
					return acc + singleItemPrice * item.qty;
				}, 0);

				return acc + pricePerTypeInBasket;
			},
			0
		);

		const pricingForPersonalisation = () => {
			let costPerItem = 0;
			let setupPrice = 0;
			if (!productData.value.personalisation) return costPerItem;

			basket.value.personalisation.forEach((personalisation) => {
				const objectName = `${personalisation.price_type}_prices`;
				const prices = productData.value.personalisation[objectName];

				if (!prices) return costPerItem;

				const variablePriceObject = personalisation.price_type.includes(
					"embroidery"
				)
					? "5000"
					: "1_colour";

				const priceBracket = prices.prices.find(
					(price, index) =>
						numberOfItemsInBasket >= price.qty &&
						(prices.prices[index + 1]
							? numberOfItemsInBasket < prices.prices[index + 1].qty
							: true)
				);

				const pricePerItem = () => {
					if (!priceBracket) return prices.setup;
					if (personalisation.large) {
						return priceBracket[`${variablePriceObject}_large`];
					} else {
						return priceBracket[variablePriceObject];
					}
				};

				const additionalColourCosts = () => {
					let setupCost = 0.0;

					if (
						variablePriceObject === "1_colour" &&
						personalisation.numberOfColours > 1
					) {
						const perColourObject = personalisation.large
							? "per_colour_large"
							: "per_colour";

						const costPerExtraColour = priceBracket
							? priceBracket[perColourObject]
							: prices.prices[0][perColourObject];
						setupCost =
							costPerExtraColour * (personalisation.numberOfColours - 1);
					}
					return setupCost;
				};

				let currentSetupPrice = parseFloat(prices.setup);
				if (
					productData.value.previous_logo.length &&
					productData.value.previous_logo.includes(personalisation.logo)
				) {
					currentSetupPrice = 0;
				}

				const personalisationCost =
					additionalColourCosts() + parseFloat(pricePerItem());
				personalisation.price_per_item = personalisationCost || 0.0;
				personalisation.setup = currentSetupPrice;
				costPerItem += personalisationCost;
				setupPrice += currentSetupPrice;
			});

			return costPerItem * numberOfItemsInBasket + setupPrice;
		};

		const totalBasketValue = (
			totalBasketValueWithoutPersonalisation + pricingForPersonalisation()
		).toFixed(2);

		const totalBasketValueWithVat =
			taxStatus.value && !productData.value.non_taxable
				? parseFloat(totalBasketValue) * 1.2
				: parseFloat(totalBasketValue);

		basket.value.total = totalBasketValueWithVat;
	};

	return {
		basket,
		calculateTotal,
	};
};
